import React, { useId } from 'react';
import type { LucideProps } from 'lucide-react';

/**
 * Liability icon component
 * Custom credit card icon from .graphics/client/liability.svg
 */
export const LiabilityIcon: React.FC<LucideProps> = ({ size = 24, className, ...props }) => {
  const id = useId();
  const cardId = `${id}-card`;
  const stripeId = `${id}-stripe`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        {/* Gold gradient for the card body - gradientTransform="translate(-108.61017)" pre-calculated */}
        <linearGradient
          id={cardId}
          gradientUnits="userSpaceOnUse"
          x1="-106.61017"
          y1="12"
          x2="-86.61017"
          y2="12"
        >
          <stop offset="0" stopColor="#c49a41" />
          <stop offset="1" stopColor="#b1a769" />
        </linearGradient>
        {/* Dark grey gradient for the stripe - gradientTransform="matrix(1,0,0,1.5084746,-108.61017,-5.6186441)" pre-calculated */}
        <linearGradient
          id={stripeId}
          gradientUnits="userSpaceOnUse"
          x1="-106.61017"
          y1="9.4661"
          x2="-86.61017"
          y2="9.4661"
        >
          <stop offset="0" stopColor="#5a5a5a" />
          <stop offset="1" stopColor="#3f3f3f" />
        </linearGradient>
      </defs>
      <g transform="matrix(1.0999999,0,0,1.0999999,118.27118,-1.1999988)">
        {/* Card body */}
        <path
          fill={`url(#${cardId})`}
          stroke="none"
          d="m -104.61017,5 c -1.108,0 -2,0.8920011 -2,2 v 10 c 0,1.107999 0.892,2 2,2 h 16 c 1.107999,0 2,-0.892001 2,-2 V 7 c 0,-1.1079989 -0.892001,-2 -2,-2 z"
        />
        {/* Magnetic stripe */}
        <rect
          fill={`url(#${stripeId})`}
          stroke="none"
          width="20"
          height="3.0169492"
          x="-106.61017"
          y="7.9576273"
        />
        {/* Chip */}
        <path
          fill="#e1cc55"
          fillOpacity="0.303797"
          stroke="none"
          d="m -100.83051,15.127119 c 1.108537,-0.03971 -0.89922,2.008472 -2.00847,2.008475 -1.10925,3e-6 -3.08725,-1.750227 -2.00848,-2.008475 1.19057,-0.285012 1.51911,-2.50117 2.00848,-2.008475 0.31876,0.320926 1.15883,2.038912 2.00847,2.008475 z"
        />
        {/* Card number placeholders */}
        <path
          fill="#818181"
          fillOpacity="0.303797"
          stroke="none"
          d="m -98.695312,13.607422 v 0.986328 h 2.085937 v -0.986328 z m 2.796874,0 v 0.986328 h 3.609376 v -0.986328 z m 4.47461,0 v 0.986328 h 3.101562 v -0.986328 z m -7.271484,2.171875 v 0.986328 h 4.271484 v -0.986328 z m 5.1875,0 v 0.986328 H -90 v -0.986328 h -1.423828 -0.865234 z m 4.117187,0 v 0.986328 h 1.068359 v -0.986328 z"
        />
      </g>
    </svg>
  );
};
